import React from "react";
import { useHistory } from "react-router-dom";

import KeyIcon from "@mui/icons-material/Key";
import { Button } from "@mui/material";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { Routes } from "constants/routes";
import { useModals } from "hooks/shared-hooks/use-modals";

import "./ExpiredPasswordModal.styles.scss";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  outline: "none"
};

export const ExpiredPasswordModal: React.FC<{
  isShow: boolean;
  onContinue: () => void;
}> = ({ isShow, onContinue }) => {
  const { closeExpiredPasswordModal } = useModals();

  const { push } = useHistory();
  return (
    <Modal open={isShow} onClose={closeExpiredPasswordModal}>
      <Box sx={style}>
        <div className="expired-password-modal">
          <div className="expired-password-modal__head">
            <div className="expired-password-modal__title">
              <KeyIcon />
              Your password is about to expire
            </div>
          </div>
          <div className="expired-password-modal__body">
            <div className="expired-password-modal__body-message">
              <span>Would you like to update your password now?</span>
            </div>
            <div className="expired-password-modal__btns">
              <Button
                onClick={() => {
                  onContinue();
                  closeExpiredPasswordModal();
                }}
              >
                Continue
              </Button>
              <Button
                onClick={() => {
                  push(Routes.changePassword);
                  closeExpiredPasswordModal();
                }}
                variant="contained"
              >
                Change Password
              </Button>
            </div>
          </div>
        </div>
      </Box>
    </Modal>
  );
};
